import React from "react";
import { Controller } from "react-hook-form";
import { RadioContainer, RadioInput, RadioLabel, Description } from "./styles";

interface IRadioButton {
  label: string;
  description?: string;
  value: string;
}

interface IRadioButtonGroupFormProps {
  name: string;
  control: any;
  options: IRadioButton[];
  rules?: any;
}

export const RadioButtonGroupForm: React.FC<IRadioButtonGroupFormProps> = ({
  name,
  control,
  options,
  rules = {},
}) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      defaultValue=""
      render={({ field, fieldState }) => (
        <>
          {options.map((option) => (
            <RadioContainer key={option.value}>
              <RadioLabel>
                <RadioInput
                  type="radio"
                  value={option.value}
                  checked={field.value === option.value}
                  onChange={() => field.onChange(option.value)}
                />
                <span className="label-text">{option.label}</span>
              </RadioLabel>
              {option.description && (
                <Description>{option.description}</Description>
              )}
            </RadioContainer>
          ))}
          {fieldState.error && (
            <span style={{ color: "red", marginTop: "5px" }}>
              {fieldState.error.message}
            </span>
          )}
        </>
      )}
    />
  );
};
